import React from 'react';

import TextBlock from '../Components/TextBlock';

const Contact = (props) => {
	return (
		<TextBlock name='Контакти'>
			<section className="s-text">
				Обговорити питання та отримати консультацію Ви можете за телефоном або в нашому офісі:<br/><br/>
				<section className="s-textb">Київ, проспект Перемоги, 89А, 3й під'їзд  </section>
				Режим роботи: <br/>
				• понеділок - четвер 3 9:30 до 18:00<br/>
				• п'ятниця з  9:30 до 15:00<br/>
				• субота, неділя за попереднім записом <br/>
				<br/>

				
				<section className="s-textb">
				</section>
				<section className="s-textb">
				Радимо домовитися про зустріч заздалегідь.<br/>
				За бажанням, наші співробітники можуть зустрітися з Вами в зручному для Вас місці і в зручний для Вас час.
				</section>
			</section>
      
			<section className="s-textb">
      <div className="telefon"> <a href="tel:+380502244324">(050) 224-43-24 </a> <br/>
      <br/>
                                  <a href="tel:+380672244324">(067) 224-43-24</a> <br/>
                                  <br/>
                                  <a href="tel:+380635312136">(063) 531-21-36</a><br/><br/>
                                  <a href="mailto:consultingur@gmail.com">consultingur@gmail.com</a>
								    <br/>  <br/>
                                  
        </div>
				<br/>
			
			</section>
			<iframe title="Карта" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1131.5234143509595!2d30.384692360732934!3d50.45629621538027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cc8af6f38529%3A0xb27dfd3b48fcf190!2z0L_RgNC-0YHQv9C10LrRgiDQn9C10YDQtdC80L7Qs9C4LCA4OdCQLCDQmtC40ZfQsiwgMDIwMDA!5e0!3m2!1sru!2sua!4v1522528626033">
			</iframe>
		
		</TextBlock>
	);
}

export default Contact;


// WEBPACK FOOTER //
// ./src/Page/Contact.jsx